// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"010292b6","262":"87926dab","453":"871f3200","626":"0a5c3cb1"}[chunkId] + ".chunk.js";
};